import axios from 'axios';
const server = process.env.REACT_APP_SERVER_URL;

export const getAEInterestOfApplication = async (idSolicitud, token) => {
  try {
    const response = await axios.get(`${server}/settlements/interes/${idSolicitud}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAEFineOfApplication = async (idSolicitud, token) => {
  try {
    const response = await axios.get(`${server}/settlements/multa/${idSolicitud}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAnualDebtAE = async (idSolicitud, token) => {
  try {
    const response = await axios.get(`${server}/settlements/deuda/${idSolicitud}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};